










































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PengantarKulturAntibiotikaInputModal from "@/components/modal/PengantarKulturAntibiotikaInputModal.vue";
import { storePengantarKulturAntibiotika } from "@/store/modules/PengantarKulturAntibiotikaStore";
import PengantarKulturAntibiotikaSvc from "@/services/PengantarKulturAntibiotika";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
    PengantarKulturAntibiotikaInputModal
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardPengantarKulturAntibiotika extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalInput = false;
  modalTtd = false;
  modalLabReg = false;
  editData: any = null;
  signItem: any = null;
  labRegItem: any = null;
  noRegLabInput = "";
  deleting = false;
  savingLab = false;

  mounted() {
    this.reload();
  }

  reload() {
    if (this.register) {
      storePengantarKulturAntibiotika.getByRegister(this.register);
    }
  }

  get items() {
    return storePengantarKulturAntibiotika.items;
  }

  get loading() {
    return storePengantarKulturAntibiotika.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get canMake() {
    const profesi = (this.stateuser.profesi || "").toLowerCase();
    return ["dokter", "perawat", "bidan"].includes(profesi);
  }

  get canIsiLab() {
    const profesi = (this.stateuser.profesi || "").toLowerCase();
    const unit = (this.stateuser.unit || "").toLowerCase();
    return profesi.includes("analis") || unit.includes("lab");
  }

  canEdit(item) {
    if (!this.canMake) return false;
    return !item.dokter_pengirim || item.dokter_pengirim.id == this.stateuser.id;
  }

  tooltipTtd(item) {
    if (this.canSignItem(item)) return "Tandatangani sebagai Dokter Pengirim";
    if (!item.dokter_pengirim) return "Dokter pengirim belum dipilih — ubah pengantar lalu pilih dokter pengirim";
    return `Menunggu tanda tangan ${item.dokter_pengirim.nama || "dokter pengirim"} — hanya akun tersebut yang dapat menandatangani`;
  }

  canSignItem(item) {
    return (
      !item.signed_pengirim &&
      item.dokter_pengirim &&
      this.stateuser.id == item.dokter_pengirim.id
    );
  }

  labelSpesimen(s: string) {
    const map: Record<string, string> = {
      darah: "Darah",
      pus: "Pus",
      urin: "Urin",
      sputum: "Sputum",
      feses: "Feses",
      lain: "Lain-lain"
    };
    return map[s] || s;
  }

  formatDate(date: string | null) {
    return date ? getHumanDateTime(date) : "-";
  }

  openInput(item: any) {
    if (this.readOnly) return;
    this.editData = item;
    this.modalInput = true;
  }

  openSign(item: any) {
    this.signItem = item;
    this.modalTtd = true;
  }

  openLabReg(item: any) {
    this.labRegItem = item;
    this.noRegLabInput = item.no_registrasi_lab || "";
    this.modalLabReg = true;
  }

  async saveLabReg() {
    if (!this.labRegItem || !this.noRegLabInput) return;
    this.savingLab = true;
    try {
      const resp = await PengantarKulturAntibiotikaSvc.updateRegistrasiLab(this.labRegItem.id, {
        no_registrasi_lab: this.noRegLabInput
      });
      if (resp.data.status == "1") {
        appModule.NoticeDelay("No. Registrasi Lab disimpan");
        this.modalLabReg = false;
        this.reload();
      }
    } finally {
      this.savingLab = false;
    }
  }

  async passTtd(password: string) {
    if (!this.signItem) return;
    const resp = await PengantarKulturAntibiotikaSvc.signPengirim(this.signItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Pengantar Kultur");
      appModule.addMsgTtd("");
      this.reload();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  onSaved() {
    this.reload();
  }

  print(item: any) {
    PengantarKulturAntibiotikaSvc.print(item.id);
  }

  async remove(item: any) {
    if (!confirm("Anda yakin akan menghapus Pengantar Kultur ini?")) return;
    if (this.deleting) return;
    this.deleting = true;
    try {
      const resp = await PengantarKulturAntibiotikaSvc.destroy(item.id);
      if (resp?.status == "1" || resp?.status == 1) {
        appModule.NoticeDelay(resp.message || "Berhasil menghapus");
        this.reload();
      }
    } finally {
      this.deleting = false;
    }
  }
}
